import React from 'react'
import { 
  array,
  object,
  number,
} from 'yup'

import icons from 'settings/icons'

import ResourceFinder from 'pages/resource/Finder'
import IconTitle from 'components/resource/IconTitle'
import PriceSummary from 'components/resource/PriceSummary'

const TotalIcon = icons.total

const team = (project) => {
  return [{
    id: 'links',
    title: `Members`,
    helperText: 'Add team members',
    list: {
      mainField: 'resource.name',
      compact: true,
      validate: array().of(object({
        meta: object({
          amount: number()
            .transform((cv, ov) => {
              return ov === '' ? undefined : cv
            })
            .required(`required`)
            .min(1, `must be at least 1`)
        })
      })),
      itemActionHandlers: {
        edit: (link, storeActions) => {
          const resource = link.resource
          storeActions.navigateTo('resource.edit', {
            section: resource.section,
            parentid: resource.parent || 'root',
            type: resource.type,
            id: resource.id,
          })
        }
      },
      table: [{
        name: 'name',
        title: 'Name',
        sortable: true,
        render: (link) => {
          return (
            <IconTitle
              type={ link.resource.type }
              title={ link.resource.name }
            />
          )
        }
      }, {
        name: 'rate',
        title: 'Rate',
        render: (link) => {
          return (
            <PriceSummary
              currency={ project.meta.currency.symbol }
              resource={ link.resource }
              amount={ 1 }
              unit={ 'day' }
            />
          )
        }
      }, {
        name: 'amount',
        title: 'Amount',
        className: 'tableSmallColumn',
        numeric: true,
        editor: (item) => ({
          id: 'meta.amount',
          noTitle: true,
          default: 0,
          inputProps: {
            type: 'number',
            className: 'inputRightAlign',
          },
        }),
      }],
      getExtraData: ({
        data,
      }) => {
        const totalAmount = data.reduce((all, link) => {
          const linkAmount = typeof(link.meta.amount) == 'number' ?
            link.meta.amount :
            0
          return all + linkAmount
        }, 0)
        return [{
          id: 'total',
          hideDelete: true,
          hideEdit: true,
          name: (
            <IconTitle
              bold
              UseIcon={ TotalIcon }
              title="Total"
            />
          ),
          rate: (
            <PriceSummary
              currency={ project.meta.currency.symbol }
              resource={{
                type: 'team',
                links: data,
              }}
              amount={ 1 }
              unit={ 'day' }
              bold
            />
          ),
          amount: totalAmount,
        }]
      },
      getDialog: ({
        open,
        onCancel,
        onSave,
      }) => (
        <ResourceFinder
          open={ open }
          title="Add"
          includeFilter={ ['labour'] }
          onCancel={ onCancel }
          onSave={ (resource) => {
            onSave({
              resource,
              meta: {
                amount: 1,
              }
            })
          } }
        />
      )
    }
  }]
}

export default team